// extracted by mini-css-extract-plugin
export var iconCart = "styles-module--iconCart--17URl";
export var cartItemContainer = "styles-module--cartItemContainer--1h33Z";
export var cartItem = "styles-module--cartItem--2LY_H";